import { render } from "./SendGoods.vue?vue&type=template&id=e7e99a54&ts=true"
import script from "./SendGoods.vue?vue&type=script&lang=ts"
export * from "./SendGoods.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__